import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-div">
      ©2024-2026 Yasiru Panduka. All Rights Reserved.
    </div>
  );
};

export default Footer;
